/**
 * @file:  满意调查度抽屉
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/9/14     1.0     First version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent,Fragment} from "react";
import { Link } from "react-router-dom";
import VipLvLevel from "@components/Icon/vip-badge/vipLvLevel";
import IconVerified from "@components/Icon/IconVerified";
import {Spin,Drawer, Tooltip,Alert} from 'antd';
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import Lang from "@/components/Lang/Lang";
import { toFixedWithCommas} from "@utils/number-util";
import {symbolMoneyUtil,isEmpty,getIntlYYMMDD,getWeek} from '@utils/utils';
import SurveyTaskFromDrawer from "@/components/SurveyTaskFromDrawer/SurveyTaskFromDrawer";
import "./surveyTaskDrawer.less";

export default class SurveyTaskList extends PureComponent {
    static defaultProps = {
        type: "", // 1:新客调研 * 2:预流失客户调研
        canOpen:false,//是否能打开抽屉
        btnName: "",//抽屉标题
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            columns:[
                {
                    cnTitle: '客户信息',
                    cnTitleId: 'KeHuLieBiao',
                    dataIndex: 'buyerCode',
                    width: 300,
                    render:(text, item, index) => (<Tooltip placement="bottomLeft"
                                                            title={<div className={"black89 intoBox"}>
                                                                <div className={"mb_4 flex-item"}>{Lang({id:"GenJinJiLu",default:"跟进记录"})}<div className={"ml_16 black66 flex-1"}>
                                                                    {
                                                                        !isEmpty(item.lastFollowDays)?<div className={"flex-item flex-item-ver-center"}>
                                                                            {/* {0} 天前跟进过 今天跟进过*/}
                                                                            <span>{item.lastFollowDays>0?Lang({id:"NTianQianGenJinGuo",default:`${item.lastFollowDays} 天前跟进过`,params:[item.lastFollowDays]}):Lang({id:"JinTianGenJinGuo",default:"今天跟进过"})}</span>
                                                                            {/* 下次跟进 4月22日 周一 (5天后) | 下次跟进 {0}*/}
                                                                            {item.nextFollowDays>=0&&item.nextFollowTime&&item.nextFollowTime>0?<Fragment>，
                                                                                <span className={"mr_8"} dangerouslySetInnerHTML={{__html: __getServerLanguage('XiaCiGenJinN', `${getIntlYYMMDD(item.nextFollowTime)+" "+getWeek(item.nextFollowTime)}（<span class="${item.nextFollowDays<0?'text-red':''}">${item.nextFollowDays===0?__getServerLanguage('JinTian'):__getServerLanguage('NTianHou',item.nextFollowDays)}</span>`)+"）。"}}>
                                                                </span>
                                                                            </Fragment>:null}
                                                                        </div>:"--"
                                                                    }
                                                                </div></div>
                                                                <div className={"mb_4"}>{Lang({id:"ShouJi",default:"手机"})}<span className={"ml_16 black66"}>{item.telCode?<span className={"mr_4"}>+{item.telCode}</span>:""} {item.mobile||"--"}</span></div>
                                                                <div className={"mb_4"}>{Lang({id:"GongSiLeiXing",default:"公司类型"})}<span className={"ml_16 black66"}>{item.companyType||"--"}</span></div>
                                                                <div className={"flex-item"}>{Lang({id:"JingYingLeiMu",default:"经营类目"})}<span className={"ml_16 black66 flex-1"}>{item.mainCategoryName||"--"}</span></div>
                                                            </div>}
                                                            arrow={false}
                                                            color={"#fff"}
                                                            // trigger={"click"}
                                                            overlayClassName={"remindDrwTooltips"}>
                        <div className={"hoverBox"}>
                            <div className={"flex-item-ver-center"}>
                                <Link target={"_blank"}
                                      className="color-blue3 fw_700 font-16"
                                      to={`/customer/detail?id=${item.id}`} >
                                    {item.buyerCode||'-'}
                                </Link>
                                {(!isEmpty(item.isTargetCustomer)||item.pointLevel&&item.pointLevel>0)?<span className={"spanLevel ml_4"}>
                                    {!isEmpty(item.isTargetCustomer)?<IconVerified className={"mr_4"} isTargetCustomer={item.isTargetCustomer} />:null}
                                    {item.pointLevel&&item.pointLevel>0?<VipLvLevel grade={item.pointLevel} width={24} />:null}
                                </span>:null}
                                {item.isKaBuyer=="1"?<span className={"ml_4 kaLabel"}>KA</span>:null}
                            </div>
                            {item.name?<div className="fw_500">{item.name}</div>:null}
                            {item.city?<div className="black45">{item.city}</div>:null}
                        </div>
                    </Tooltip>),
                },
                {
                    cnTitle: '第一个订单时间',
                    cnTitleId: 'DiYiGeDingDanShiJian',
                    dataIndex: 'firstOrderTime',
                    width: 200,
                    render:(poCode, row, index) => (<>
                        <div className={"mb_4"}>{row.firstOrderTime?getIntlYYMMDD(row.firstOrderTime,"HH:mm"):"-"}</div>
                    </>)
                },
                {
                    cnTitle: '最近下单',
                    cnTitleId: 'ZuiJinXiaDan',
                    dataIndex: 'poCode',
                    width: 200,
                    render:(poCode, row, index) => (<>
                        {poCode?<div className={"black89"}>{poCode}</div>:null}
                        <div>{row.lastOrderTime?getIntlYYMMDD(row.lastOrderTime,"HH:mm"):"-"}</div>
                    </>)
                },
                {
                    cnTitle: '最近访问时间',
                    cnTitleId: 'ZuiJinFangWenShiJian',
                    dataIndex: 'lastVisitTime',
                    render:(lastVisitTime, row, index) => ( <span>{row.lastVisitTime&&getIntlYYMMDD(row.lastVisitTime,"HH:mm")}</span>)
                },
                {
                    cnTitle: '操作',
                    cnTitleId: 'CaoZuo',
                    dataIndex: 'CaoZuo',
                    width: 120,
                    fixed:"right",
                    render: (item = {}, row) => (<>
                        <SurveyTaskFromDrawer item={row}
                                              title={props.btnName}// 标题要统一显示新客满意度调查或预流失客户满意度调查
                                              buyerSurveyTaskId={row.buyerSurveyTaskId}
                                              refreshPage={()=>this.refreshPage()}  />
                   </> )
                }
            ],
        }
    }
    /**
     * 抽屜
     * */
    showDrawer = (flag=true) => {
        if(this.props.showDrawer){ // 打开抽屉后回调
            this.props.showDrawer(flag)
        }
        this.setState({
            visible: flag,
        });
    }
    /**
     * 刷新
     *
     */
    refreshPage(){
        this.onPageTemplateTableChild.handleFetch(1,{},true);
        if(this.props.refreshPage){
            this.props.refreshPage();
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /*
*  type: 显示 类型 1 新客 满意度调查 2 预流失用户满意度调查
* */
    getTips(type){
        switch (type) {
            case 1:
                return Lang({id:"DaiBanTiShiXinKeHu",
                    default:'<p>调研目的：了解新客户对首单服务的满意度评价，及时发现问题完善服务，避免新客户的流失。并进一步促进第2-3个订单成交。</p> <p>沟通话术：</p> <p>xxx,您好！我是ESSAONE网站的客服人员。因为您是第一次在ESSAONE订购，我们想对您进行首次订购的满意度调查，能占用您几分钟时间参与本次答题吗？。您的意见将有助于ESSAONE变得更好。</p> <p>1）客户回答-YES。开始答题。</p> <p>2）客户回答-NO。现在很忙。需询问客户下次方便电话的时间。</p>'})
            case 2:
                return Lang({id:"DaiBanTiShiYuLiuShiDiaoYan",
                    default:'<p>调研目的：了解平台流失用户的流失原因，改善处理平台存在的不友好问题，避免后续流失，同时为流失用户的召回提供决策依据。</p> <p>沟通话术：</p> <p>xxx,您好！我是ESSAONE网站的客服人员。我们正在进行用户满意度调查，能占用您几分钟时间参与本次答题吗？。您的意见将有助于ESSAONE变得更好。</p> <p>1）客户回答-YES。开始答题。</p> <p>2）客户回答-NO。现在很忙。请询问客户下次方便电话的时间。</p>'})
            default:
                return ""
        }

    }
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    componentWillMount() {
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const {className,children,btnName,canOpen=false,type="" } = this.props;
        const {loading = false,columns=[],visible=false,} = this.state;
        return (<Fragment>
             <div className={`${canOpen?"cursor-p":""}${className?" "+className:""}`} onClick={()=>this.showDrawer(canOpen?true:false)}>{children}</div>
            <Drawer title={<div className={"flex-item-ver-center lineH_27"}>
                                <span className={"font_18 fw_500"}>{btnName}</span>
                        </div>}
                    width={1100}
                    rootClassName={"surveyTaskDrawerWrap"}
                    // maskClosable={false}
                    destroyOnClose={true}
                    onClose={()=>this.showDrawer(false)}
                    open={visible}>
                        <Spin spinning={loading}>
                            <div className={"mb_12 alertMsg"}>
                                <Alert description={<div dangerouslySetInnerHTML={{__html:this.getTips(type)}} />}
                                       type="info" showIcon
                                       icon={<i className="ri-information-fill" style={{fontSize: "18px", marginTop: "10px", marginRight: "4px"}} />} />
                            </div>
                            <AutoFetchTable columns={columns}
                                            onRef={this.onRefTabOne}
                                            precondition={{ //前置条件
                                                type: type,//1:新客调研 * 2:预流失客户调研
                                            }}
                                            flagShowReset={false}
                                            flagShowSearchBtn={false} // http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8315
                                            fetchApi={'/service/mg/home/survey-task/list'}>
                            </AutoFetchTable>
                    </Spin>
            </Drawer>
        </Fragment>);
    }
}